import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import config from 'config';
import Header from './Header';
import Navigation from './Navigation';
import TabContent from './Subnavigation/TabContent';
import PreCache from '../widgets/Precache';
import {
  setLayout,
  loadPageStats,
  createNewsSubscription,
  switchPanel
} from '../../redux/App/actions';

import './layout.scss';

import data from '../../content/main.json';
import tabs from '../../content/navigation.json';

const ESC = 27;

class Layout extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: this.getActiveTabIndex(this.props.location.pathname)
    };
  }

  componentDidMount() {
    this.props.setLayout(window.innerWidth);
    window.addEventListener('resize', this.onWindowResize);
    window.addEventListener('keydown', this.onKeyDown);

    this.props.loadPageStats();
  }

  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;

    if (this.props.location.pathname !== pathname) {
      this.setState({
        activeIndex: this.getActiveTabIndex(pathname)
      });

      this.onPanelSwitch();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('keydown', this.onKeyDown);

    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  }

  onKeyDown = (event) => {
    if (event.keyCode === ESC) {
      this.onPanelSwitch();
    }
  };

  onWindowResize = () => {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }

    this.resizeTimer = setTimeout(() => {
      this.resizeTimer = null;
      this.props.setLayout(window.innerWidth);
    }, 50);
  };

  isTabsEnabled = (pathname) => {
    return !(
      pathname === '/' ||
      (pathname.startsWith('/we/news/') && pathname !== '/we/news/') ||
      (pathname.startsWith('/analyze/actually/') &&
        pathname !== '/analyze/actually/')
    );
  };

  getActiveTabIndex = (pathname) => {
    return tabs.findIndex((tab) => {
      return (
        pathname.startsWith(tab.pathname) ||
        tab.links.findIndex((link) => pathname.startsWith(link.pathname)) !== -1
      );
    });
  };

  isTabContentEnabled = (pathname) => {
    return tabs.findIndex((tab) => pathname === tab.pathname) !== -1;
  };

  isSubnavigationPage = (pathname) => {
    return (
      tabs.findIndex((tab) => pathname === `${tab.pathname}subnavigation/`) !==
      -1
    );
  };

  getLogoUrl = (pathname) => {
    if (pathname === '/' || !!this.isTabContentEnabled(pathname)) {
      return pathname;
    }

    const tabIndex = this.getActiveTabIndex(pathname);

    if (tabIndex === -1) {
      return '/we/';
    }

    return tabs[tabIndex].pathname;
  };

  onLayoutClick = (event) => {
    if (!this.props.panel) {
      return;
    }

    if (!this.nav.contains(event.target)) {
      if (event) {
        event.preventDefault();
      }

      this.onPanelSwitch();
    }
  };

  onPanelSwitch = (panelName) => {
    const panel = typeof panelName === 'string' ? panelName : null;

    if (!!panel) {
      document.documentElement.classList.add('nav-open');
    } else {
      document.documentElement.classList.remove('nav-open');
    }

    this.props.switchPanel(panel);
  };

  onSubscribeClick = () => {
    this.onPanelSwitch('subscribe');
  };

  onNavigationClick = () => {
    this.onPanelSwitch('navigation');
  };

  onLoginClick = () => {
    var tokenrem = getCookie('token_rem');
    if (tokenrem != null) {
      fetch('https://api.uscapital.ru/api/check', {
        method: 'POST',
        body: JSON.stringify({
          token_rem: tokenrem
        })
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.error) {
            this.onPanelSwitch('login');
          } else {
            document.cookie =
              'token=' + res.userData.token + '; domain=.uscapital.ru; path=/';
            document.location.href = `${config.appProtocol}://my.uscapital.ru`;
          }
        });
    } else {
      this.onPanelSwitch('login');
    }
    function getCookie(name) {
      var matches = document.cookie.match(
        new RegExp(
          '(?:^|; )' +
            name.replace(/([.$?*|{}()[]\\\/\+^])/g, '\\$1') +
            '=([^;]*)'
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
  };

  render() {
    const { pathname } = this.props.location;

    const logoUrl = this.getLogoUrl(pathname);
    const showNavigation = this.isTabsEnabled(pathname);
    const activeTabIndex = this.getActiveTabIndex(pathname);
    const showTabContent = this.isTabContentEnabled(pathname);
    const subnavigationPage = this.isSubnavigationPage(pathname);

    return (
      <div className="layout" onClick={this.onLayoutClick}>
        <div>
          <PreCache loading={this.props.loading} />
        </div>

        <Header
          logoUrl={logoUrl}
          onNavigationClick={this.onNavigationClick}
          onLoginClick={this.onLoginClick}
        />

        <div className="page">{this.props.children}</div>

        {/* <div>
          {(showNavigation) &&
            <TabContent
              activeTabIndex={activeTabIndex}
              activeTab={tabs[activeTabIndex]}
              isMobile={this.props.isMobile}
              navigationTabs={tabs}
              infoData={this.props.infoData}
              showTabContent={showTabContent}
              subnavigationPage={subnavigationPage}
              onSubscribeClick={this.onSubscribeClick}
            />
          }
        </div>

        <div ref={elem => { this.nav = elem; }}>
          <Navigation
            activeTabIndex={activeTabIndex}
            links={tabs}
            panel={this.props.panel}
            onPanelSwitch={this.onPanelSwitch}
            createSubscription={this.props.createNewsSubscription}
          />
        </div> */}
      </div>
    );
  }
}

Layout.propTypes = {
  loading: PropTypes.bool,
  infoData: PropTypes.object,
  isMobile: PropTypes.bool,
  setLayout: PropTypes.func.isRequired,
  loadPageStats: PropTypes.func.isRequired,
  createNewsSubscription: PropTypes.func.isRequired,
  switchPanel: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  loading: state.precache.loading,
  isMobile: state.app.layout === 'mobile',
  infoData: data,
  panel: state.app.panel
});

export default connect(mapStateToProps, {
  setLayout,
  loadPageStats,
  createNewsSubscription,
  switchPanel
})(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/index.js